import React, { useMemo } from 'react';
import {
  ListContainer,
  MemberItem,
  MemberMeta,
  MemberName,
  TimeRow,
  CountRow,
  LeftSection,
  NameTimeGroup,
  MemberHoursGroup,
  TotalHours,
  TimeText,
  CountText,
  Counter,
  Icon
} from './styles';
import Avatar from '../../avatar';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { WorkloadReportMemberInterface } from '../../../interfaces/ReportInterface';
import { AVATAR_BORDER, ICON_SIZE } from '../../../global/constants';

interface WorkspaceUserInterface {
  id: string;
  name: string;
  profile_photo?: string;
  avatar?: { avatar?: string };
}

interface WorkloadLeftSectionProps {
  workloadData?: WorkloadReportMemberInterface[] | null;
  workspaceUsers?: WorkspaceUserInterface[];
  selectedUserIds?: string[];
}

const WorkloadLeftSection: React.FC<WorkloadLeftSectionProps> = ({ workloadData, workspaceUsers, selectedUserIds }) => {
  const members = useMemo(() => {
    const users = workspaceUsers ?? [];
    const usersToShow =
      selectedUserIds && selectedUserIds.length > 0 ? users.filter((u) => selectedUserIds.includes(u.id)) : users;
    return usersToShow
      .filter((user) => !!user?.id && !user.id.toLowerCase().startsWith('agent_'))
      .map((user) => {
        const workload = workloadData?.find((member) => member.id === user.id);
        const avatarUrl = workload?.avatarUrl || user.profile_photo || user.avatar?.avatar || '';

        return {
          id: user.id,
          name: workload?.name || user.name,
          avatarUrl: avatarUrl || '',
          totalHours: workload?.totalHours ?? '0h',
          totalWorkingHours: workload?.totalWorkingHours ?? '0h',
          overloadTime: workload?.overloadTime ?? '0h',
          totalOvertimeHours: workload?.totalOvertimeHours ?? 0,
          tasksCount: workload?.tasksCount ?? 0,
          projectsCount: workload?.projectsCount ?? 0
        };
      });
  }, [workspaceUsers, selectedUserIds, workloadData]);

  if (!workspaceUsers || workspaceUsers.length === 0) {
    return <div>No members available</div>;
  }

  return (
    <>
      <ListContainer>
        {selectedUserIds &&
          selectedUserIds.length > 0 &&
          members.map((member) => {
            return (
              <MemberItem key={member.id}>
                <LeftSection>
                  <Avatar imgSrc={member.avatarUrl} name={member.name} size={40} borderVariant={AVATAR_BORDER.NONE} />
                </LeftSection>
                <MemberMeta>
                  <NameTimeGroup>
                    <MemberHoursGroup>
                      <MemberName>{member.name}</MemberName>
                      <TotalHours>{member.totalHours}</TotalHours>
                    </MemberHoursGroup>
                    <TimeRow>
                      <TimeText className={`working-hours ${member.totalOvertimeHours === 0 ? 'no-border' : ''}`}>
                        {member.totalWorkingHours}
                      </TimeText>
                      {member.totalOvertimeHours > 0 && <TimeText className='overload'>{member.overloadTime}</TimeText>}
                    </TimeRow>
                  </NameTimeGroup>
                  <CountRow>
                    <Counter>
                      <Icon>
                        <SVGIcon
                          name='navbar-MyTask-icon'
                          width={ICON_SIZE.MD}
                          height={ICON_SIZE.MD}
                          viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                          fill='var(--text-secondary)'
                        />
                      </Icon>
                      <CountText>{member.tasksCount} Tasks</CountText>
                    </Counter>
                    <Counter>
                      <Icon>
                        <SVGIcon
                          name='project-icon'
                          width={ICON_SIZE.MD}
                          height={ICON_SIZE.MD}
                          viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                          fill='var(--text-secondary)'
                        />
                      </Icon>
                      <CountText>{member.projectsCount} Projects</CountText>
                    </Counter>
                  </CountRow>
                </MemberMeta>
              </MemberItem>
            );
          })}
      </ListContainer>
    </>
  );
};

export default WorkloadLeftSection;
